<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" textColor="#a63232">
      <inline-svg :src="require('@/assets/svg/close_red.svg')" width="20" />
      Decline Interview
    </SecondaryButton>
    <EditInterviewParticipantStatusDialog
      v-if="isDialogOpen"
      :isOpen="isDialogOpen"
      @close="closeDialog"
      title="Why do you want to decline this interview?"
      buttonType="error"
      buttonText="Decline Interview"
      status="declined"
    />
  </BaseAction>
</template>

<script>
import EditInterviewParticipantStatusDialog from "@/views/interviews/dialogs/EditInterviewParticipantStatusDialog";
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import InlineSvg from "vue-inline-svg";

export default {
  name: "DeclineInterviewAction",
  components: {
    BaseAction,
    SecondaryButton,
    EditInterviewParticipantStatusDialog,
    InlineSvg
  },
  data() {
    return {
      isDialogOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>
